import type { DocumentDesign } from "../../api/types";
import type { DocumentDesignState } from "../../canvas/state/types";
import type { CanvasPaperConfig } from "./PageDesigner";

export function getPaperConfig(
  canvasPaperConfig: CanvasPaperConfig,
): DocumentDesign["paper_config"] {
  return {
    paper_size: JSON.stringify({
      height: canvasPaperConfig.height,
      width: canvasPaperConfig.width,
    }),
    orientation: canvasPaperConfig.orientation,
    background_style: "blank",
    padding_directions: JSON.stringify(canvasPaperConfig.paddingDirections),
    page_break_margin: canvasPaperConfig.pageBreakMargin,
  };
}

export function getPartialDocument(
  documentDesign: DocumentDesign,
  state: DocumentDesignState,
  canvasPaperConfig: CanvasPaperConfig,
): Partial<DocumentDesign> {
  return {
    id: documentDesign.id,
    name: documentDesign.name,
    canvas_template: state,
    paper_config: getPaperConfig(canvasPaperConfig),
  };
}
